<script lang="ts">
    import type {DirectoryNode} from 'src/typings';
    import {FileViewForm} from 'shared/constants';
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import type {MediaViewerFile} from 'src/features/media-viewer/lib/mv-types';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {isDirectoryNode, isMediaViewerFile} from '../../lib/mv-utils';

    export let directoryOrFile: DirectoryNode | MediaViewerFile;

    function getIcon(obj: DirectoryNode | MediaViewerFile): UIcons {
        if (isDirectoryNode(obj)) {
            return 'folder';
        }

        if (!isMediaViewerFile(obj)) {
            return 'file';
        }

        if (obj.viewForms.includes(FileViewForm.THUMBNAIL)
            || obj.viewForms.includes(FileViewForm.IMAGE)) {
            return 'file-image';
        }

        if (obj.viewForms.includes(FileViewForm.PDF)) {
            return 'file-pdf';
        }

        if (obj.viewForms.includes(FileViewForm.AUDIO)) {
            return 'file-audio';
        }

        if (obj.viewForms.includes(FileViewForm.VIDEO)) {
            return 'file-video';
        }

        if (obj.viewForms.includes(FileViewForm.DOCUMENT) ||
            obj.viewForms.includes(FileViewForm.PLAIN_TEXT) ||
            obj.viewForms.includes(FileViewForm.RICH_DOCUMENT)) {
            return 'document';
        }

        return 'file';
    }
</script>

<UIcon icon={getIcon(directoryOrFile)}/>